export default __webpack_public_path__ + "static/media/goshen106.9cf66320.jpg";